<template>
  <div class="wrapper">
    <header>
      <router-link to="/"
        ><img src="@/assets/images/logo-mixa-min.png"
      /></router-link>
    </header>
    <main class="h-full bg-[#EBF2FA] flex items-end justify-center">
      <div>
        <router-link to="/"
          ><img src="@/assets/images/merci.jpg" class="merci"
        /></router-link>
      </div>
    </main>
    <footer>
      <div class="bg-[#EBF2FA] flex flex-wrap -mt-1 justify-center"></div>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$router.push("/");
    }, 10000);
  },
};
</script>
